export default __webpack_public_path__ + "static/media/link-navi-bg.991d0cb5.png";